import { Grid } from '@mui/material';
import Loading from '../../../../../components/general/loadings/loading';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

import { useFunctionariesSwitchData } from './hook';
import { FunctionariesSwitchDataProps } from './props';

export const FunctionariesSwitchData = ({
    functionariesSwitch,
    loading,
}: FunctionariesSwitchDataProps) => {
    const { formik } = useFunctionariesSwitchData(functionariesSwitch);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    value={formik.values.name}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Apellido"
                    name="surname"
                    size="small"
                    disabled
                    value={formik.values.surname}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Correo electrónico"
                    name="email"
                    size="small"
                    disabled
                    value={formik.values.email}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Teléfono"
                    name="phone"
                    size="small"
                    disabled
                    value={formik.values.phone}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Extensión"
                    name="extension"
                    size="small"
                    disabled
                    value={formik.values.extension}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    disabled
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Área"
                    name="area"
                    size="small"
                    disabled
                    value={formik.values.area}
                    onChange={undefined}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Cargo"
                    name="position"
                    size="small"
                    disabled
                    value={formik.values.position}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={2}
                    disabled
                    value={formik.values.description}
                    onChange={undefined}
                />
            </Grid>
        </Grid>
    );
};
